import { useState, useEffect } from "react";
import CustomLoading from "../../utils/LoadingIndicator/CustomLoading";
import useFetchProduct from "../adminDashboard/products/useFetchProduct";
import ProductCard from "../adminDashboard/products/utils/ProductCard";

const RecentProducts = () => {
  const { products, isGettingProducts, errGettingProducts } = useFetchProduct();
  const [recentProducts, setRecentProducts] = useState([]);

  useEffect(() => {
    // Get viewed products from localStorage
    const viewedProducts = JSON.parse(
      localStorage.getItem("viewedProducts") || "[]"
    );

    // Get product details for viewed products
    const recentProductsWithDetails = viewedProducts
      .map((viewedId) => products?.data?.find((p) => p._id === viewedId))
      .filter(Boolean) // Remove any undefined products
      .slice(0, 4); // Get only the 4 most recent

    setRecentProducts(recentProductsWithDetails);
  }, [products]);

  if (isGettingProducts) {
    return (
      <div className="recent-products">
        <h2 className="text-2xl font-bold mb-4">Recently Viewed Products</h2>
        <div className="flex justify-center items-center">
          <CustomLoading size="2rem" />
        </div>
      </div>
    );
  }

  if (errGettingProducts) {
    return (
      <div className="recent-products">
        <h2 className="text-2xl font-bold mb-4">Recently Viewed Products</h2>
        <div className="text-center p-4 bg-red-50 text-red-600 rounded-lg">
          <p>Failed to load recent products. Please try again later.</p>
        </div>
      </div>
    );
  }

  if (!recentProducts?.length) {
    return <></>;
  }

  return (
    <div className="recent-products">
      <div className="container">
        <h2 className="text-2xl font-bold mb-4 uppercase">
          Recently Viewed Products
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {recentProducts.map((product) => (
            <div
              key={product._id}
              // className="border rounded-lg p-4 hover:shadow-lg transition-shadow"
            >
              <ProductCard product={product} />
              {/* <div className="relative">
              <img
                src={`${API}/products/photo/${product._id}`}
                alt={product.name}
                className="w-full h-48 object-contain mb-4"
                loading="lazy"
              />
              {product.discount > 0 && (
                <div className="absolute top-2 right-2 bg-[#DA0E1A] text-white px-2 py-1 rounded-full text-sm font-bold">
                  {product.discount}% OFF
                </div>
              )}
            </div>
            <h3 className="font-semibold text-lg mb-2 line-clamp-2">
              {product.name}
            </h3>
            <div className="flex items-center gap-2 mb-2">
              {product.discount > 0 ? (
                <>
                  <p className="text-green-700 font-bold">
                    {product.price - (product.price * product.discount) / 100}{" "}
                    EGP
                  </p>
                  <p className="text-gray-500 line-through text-sm">
                    {product.price} EGP
                  </p>
                </>
              ) : (
                <p className="text-green-700 font-bold">{product.price} EGP</p>
              )}
            </div>
            <Link
              to={`/product/${product._id}`}
              className="w-full block text-center text-xl bg-[#DA0E1A] text-white py-2 rounded-lg hover:bg-red-700 transition-colors"
            >
              View Product
            </Link> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecentProducts;
